import { Dtos, SuretyAccountId, SuretyQuoteId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { bondRequestContractExtractionsQueryKey } from "../bond-request.keys";

type UseFetchAdminContractExtractionsParams = {
	accountId: SuretyAccountId;
	quoteId: SuretyQuoteId;
	enabled?: boolean;
};

export const useFetchAdminContractExtractions = ({
	accountId,
	quoteId,
	enabled = true,
}: UseFetchAdminContractExtractionsParams) => {
	const { get } = useRequest();

	const { data } = useQuery({
		queryKey: bondRequestContractExtractionsQueryKey(quoteId),
		queryFn: () =>
			get<Dtos.ContractExtraction.Get.Response[]>(
				`/v2/admin/surety/accounts/${accountId}/quotes/${quoteId}/contract-extractions`,
			),
		enabled,
	});

	return { extractions: data };
};
